export const ICON_SIZE = 'xxs';
export const ROOT_SIZE = {
    lg: 32,
    md: 24,
    sm: 18,
};
